export const componentsContainer = ['div', 'ol', 'ul'];
export const componentsItemMap = {
    div: 'div',
    ol: 'li',
    ul: 'li',
};
